
import get from 'lodash/get';

import Log from './log';
const log = Log.getLogger('MultiSceneForApp.core.module');

export default class Module {

    constructor(id) {
        this._id = id;
        this._options = {};
        this._commands = [];
        this._store = null;
    }

    addCommand(command) {
        this._commands.push(command);
    }

    executeCommand(commandDefinition, dispatch, store) {
        let {command, ...params} = commandDefinition;
        let commandObject = this.getCommand(command);
        if (commandObject) {
            if (commandObject.execute) {
                commandObject.execute(params, dispatch, store);
            }
        } else {
            log.warn(`unknown command "${command}"`);
        }
    }

    getCommand(name) {
        return this._commands.reduce((previous, current) => {
            return (current.name === name)
                ? current
                : previous;
        }, null);
    }

    getId() {
        return this._id;
    }

    getOptions() {
        return this._options;
    }

    getStore() {
        return this._store;
    }

    init(options) {
        log.debug(`init module "${this._id}"`);
        this._options = get(options, this.getId(), {});
        this.initCommands();
    }

    initCommands() {
        // nop;
    }

    initStore(store) {
        this._store = store;
    }

    execModuleFunction(name, params) {
        if (this[name]) {
            this[name](params);
        }
    }
}
